module.exports = __webpack_public_path__ + "img/28.8422391f.jpg";